import { API_HOST, API_ROOT, http } from "../../../../util/http";

import React from 'react';
import ui from "../../../../util/ui";
import { validateForm } from "../../../../util/validation";

import Form from "../../form";
import TextInput from "../../../atoms/text-input";
import HiddenInput from "../../../atoms/hidden-input";

class RegisterTransactionCreate extends React.Component {

  static defaultProps = {
    register: null,
    type: null,
    onSave: () => {}
  };

  constructor(props) {

    super(props);

    this.form = React.createRef();
  }

  validateForm(form, data) {

    validateForm(form, data, {
      note: ['required'],
      amount: ['required', 'number']
    });
  }

  onSubmit(registerData) {

    http.post(API_HOST+API_ROOT+'registers/'+this.props.register.id+'/transactions', registerData, true
    ).then(response => {
      if (response.success) {
        this.props.onSave(response.result);
      }
    }).catch(error => {
      ui.notify('There was an error, register transaction couldn\'t be created');
    });
  }

  render() {

    return (
        <Form
            ref={this.form}
            validate={(form, data) => this.validateForm(form, data)}
            onSubmit={(data) => this.onSubmit(data)}
            submitButtonText={(this.props.type === 'in' ? 'Add' : 'Remove')}
        >
          <HiddenInput name="type" value={this.props.type} />
          <TextInput name="note" label="Title" showRequiredIndicator={true} focus={true} />
          <TextInput name="amount" label="Amount" showRequiredIndicator={true} />
        </Form>
    );
  }
}

export default RegisterTransactionCreate;